import { UserResponse } from '../../models/auth.model';
import { UserRole } from '../constants/keys.constant';
import {
  ProfileStepsCompleted
} from '../constants/signUpStepper.const';
import { Router } from '@angular/router';

export function profileRouteNavigator(
  profile: UserResponse,
  router: Router,
  url: string = ''
): void {

  const userRoutes = ['/my-profile', '/manage-session', '/calendar'];
  switch (profile.profileStepsCompleted) {
  case ProfileStepsCompleted.InitialScreen:
    handleCaseForInitialScreen(profile, router);
    break;
  case ProfileStepsCompleted.InitialTutorCounsellorSelected:
  case ProfileStepsCompleted.TutorCounsellorPersonalDetailDone:
  case ProfileStepsCompleted.TutorCounsellorProfessionalDetailDone:
  case ProfileStepsCompleted.TutorCounsellorExpertiseDetailDone:
    router.navigate(['/auth/tutorCounsellor-profile-setup']);
    break;
  case ProfileStepsCompleted.TutorCounsellorProfileDone:
    // router.navigate(['/tutor/dashboard']);
    break;
  case ProfileStepsCompleted.InitialStudentParentSelected:
  case ProfileStepsCompleted.InitialStudentParentServiceInterestAdded:
  case ProfileStepsCompleted.StudentDetailsInitialAddedByStudent:
  case ProfileStepsCompleted.StudentFamilyDetailsEntered:
    router.navigate(['/auth/profile']);
    break;
  case ProfileStepsCompleted.StudentAcademicDetailsEntered:
  case ProfileStepsCompleted.SkippedAtStudentFamilyScreen:
  case ProfileStepsCompleted.SkippedAtStudentAcademicScreen:
  case ProfileStepsCompleted.ParentSkippedAtStudentDetail:
  case ProfileStepsCompleted.ParentSkippedAtAcademicDetail:
    if (userRoutes.includes(url)) {
      break;
    } else if (url.includes('/manage-tutoring')) {
      break;
    } else if (url.includes('/manage-session')) {
      break;
    } else if (url.includes('/manage-counselling')) {
      break;
    } else if (url.includes('/manage-students')) {
      break;
    } else if (url.includes('/action-plan')) {
      break;
    } else if (url.includes('/manage-courses')) {
      break;
    } else if (url.includes('/support')) {
      break;
    } else if (url.includes('/manage-setting')) {
      break;
    } else if (url.includes('/my-profile')) {
      break;
    } else if (url.includes('/manage-notification')) {
      break;
    } else if (url.includes('/dashboard/progress')) {
      break;
    } else if (url.includes('/chat')) {
      break;
    } else {
      router.navigate(['/dashboard']);
      break;
    }
  default:
    profile.role === UserRole.TUTOR || profile.role === UserRole.COUNSELOR  ? router.navigate(['/tutor/dashboard']) : router.navigate(['/dashboard']);
    break;
  }
}

export function handleCaseForInitialScreen(
  profile: UserResponse,
  router: Router
): void {
  switch (profile.role) {
  case UserRole.TUTOR:
  case UserRole.COUNSELOR:
    router.navigate(['/auth/tutorCounsellor-profile-setup']);
    break;
  default: 
    router.navigate(['/auth/profile-setup']);
    break;
  }
}
